import { Layout } from "antd";
import { ReactComponent as Close } from "assets/icons/close.svg";
import { useTranslation } from "react-i18next";

const { Header } = Layout;

const PageHeader = ({ goBack, isScrolled }) => {
  const { t } = useTranslation();

  return (
    <Header
      className={`fixed h-auto top-0 px-5 w-full max-w-2xl mx-auto py-3 z-40 transition-colors duration-300 ${
        isScrolled ? "bg-white" : "bg-transparent"
      }`}
    >
      <div className=" flex justify-between items-center ">
        <div />
        <span className="text-gray-0 body-14px-regular">
          {t("card-page.promotion-title")}
        </span>
        <Close
          className="w-6 h-6 [&>path]:stroke-black"
          onClick={() => goBack()}
        />
      </div>
    </Header>
  );
};

export default PageHeader;
